import React, { Suspense } from 'react'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import Card from 'src/components/Card'
import useToggleState from 'src/hooks/useToggleState'
import Body from './Body'
import List from './List'
import EditModel from './EditModal'

interface RatesProps {
  id: number
}

const Rates: React.FC<RatesProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()

  return (
    <>
      <Card
        title='Rates'
        primaryAction={{
          key: 'edit-position-rates',
          icon: faPencil,
          onClick: handleToggle,
          permissionKey: 'CAT_EDIT'
        }}
      >
        <Suspense fallback={<List position={undefined} />}>
          <Body id={id} />
        </Suspense>
      </Card>
      <EditModel id={id} isOpen={isOpen} toggle={handleToggle} />
    </>
  )
}

export default Rates
